module.exports = __webpack_public_path__ + "img/add_sample_02.5b40d62b.png";